import { inject, Injectable } from '@angular/core';
import { limit, orderBy } from '@angular/fire/firestore';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { shareReplay, switchMap } from 'rxjs';
import { FirestoreService } from './firestore.service';
import { TenantContextService } from './tenant-context.service';

export interface RequestEmailCampaign {
  userIds: string[];
  subject: string;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class EmailsService {
  private readonly firestore = inject(FirestoreService);
  private readonly tenantContext = inject(TenantContextService);
  private readonly functions = inject(Functions);

  private get cols() {
    return this.tenantContext.collections;
  }

  readonly emails$ = this.tenantContext.tenantId$.pipe(
    switchMap(() =>
      this.firestore.listDocuments(
        this.cols.EMAILS,
        orderBy('sentAt', 'desc'),
        limit(20),
      ),
    ),
    shareReplay(1),
  );

  sendCampaign(data: RequestEmailCampaign) {
    const callable = httpsCallable<RequestEmailCampaign, void>(
      this.functions,
      'adminSendEmailCampaign',
    );
    return callable(data);
  }
}
